import trialFilters from './dashboards/clinicaltrials/filters';

const filters = (type: string) => {
    if (type === 'clinical-trials-cancer') {
        return trialFilters;
    }
};

export default filters;
